import { render, staticRenderFns } from "./educationBenefits.vue?vue&type=template&id=c21041b4&scoped=true"
import script from "./educationBenefits.vue?vue&type=script&lang=js"
export * from "./educationBenefits.vue?vue&type=script&lang=js"
import style0 from "./educationBenefits.vue?vue&type=style&index=0&id=c21041b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21041b4",
  null
  
)

export default component.exports